import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BarRatingModule } from "ngx-bar-rating";
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { TranslateModule } from '@ngx-translate/core';

// Header and Footer Components
import { HeaderOneComponent } from './header/header-one/header-one.component';
import { FooterOneComponent } from './footer/footer-one/footer-one.component';
import { HeaderTwoComponent } from './header/header-two/header-two.component';
import { FooterTwoComponent } from './footer/footer-two/footer-two.component';
import { HeaderThreeComponent } from './header/header-three/header-three.component';
import { FooterThreeComponent } from './footer/footer-three/footer-three.component';
import { HeaderFourComponent } from './header/header-four/header-four.component';
import { FooterFourComponent } from './footer/footer-four/footer-four.component';

// Components
import { LeftMenuComponent } from './components/left-menu/left-menu.component';
import { MenuComponent } from './components/menu/menu.component';
import { SettingsComponent } from './components/settings/settings.component';
import { CategoriesComponent } from './components/categories/categories.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ProductBoxOneComponent } from './components/product/product-box-one/product-box-one.component';
import { TopCollectionComponent } from './components/product/top-collection/top-collection.component';
import { ProductBoxTwoComponent } from './components/product/product-box-two/product-box-two.component';
import { ProductBoxThreeComponent } from './components/product/product-box-three/product-box-three.component';
import { ProductBoxFourComponent } from './components/product/product-box-four/product-box-four.component';
import { ProductBoxFiveComponent } from './components/product/product-box-five/product-box-five.component';
import { ProductBoxVerticalComponent } from './components/product/product-box-vertical/product-box-vertical.component';
import { ProductBoxVerticalSliderComponent } from './components/product/product-box-vertical-slider/product-box-vertical-slider.component';

// Modals Components
import { NewsletterComponent } from './components/modal/newsletter/newsletter.component';
import { PopUpComponent } from './pop-up/pop-up.component';
import { QuickViewComponent } from './components/modal/quick-view/quick-view.component';
import { CartModalComponent } from './components/modal/cart-modal/cart-modal.component';
import { CartVariationComponent } from './components/modal/cart-variation/cart-variation.component';
import { VideoModalComponent } from './components/modal/video-modal/video-modal.component';
import { SizeModalComponent } from './components/modal/size-modal/size-modal.component';
import { AgeVerificationComponent } from './components/modal/age-verification/age-verification.component';

// Skeleton Loader Components
import { SkeletonProductBoxComponent } from './components/skeleton/skeleton-product-box/skeleton-product-box.component';
// import { CardsComponent } from './';


// Layout Box
import { LayoutBoxComponent } from './components/layout-box/layout-box.component';

// Tap To Top
import { TapToTopComponent } from './components/tap-to-top/tap-to-top.component';

// Pipes
import { DiscountPipe } from './pipes/discount.pipe';
import { DialogCountBlessingsComponent } from './feature/dialog/dialog-count-blessings/dialog-count-blessings.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatStepperModule } from '@angular/material/stepper';
import { MatOptionModule } from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {MatTabsModule} from '@angular/material/tabs';
import { ExclusiveFeaturesComponent } from './components/product/exclusive-features/exclusive-features.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { CollapsibleComponent } from './components/collapsible/collapsible.component';
import { UnixTimestampToDatePipe } from './pipes/unix-timestamp-to-date.pipe';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FaqsListComponent } from './components/faqs-list/faqs-list.component';
import { DashboardCommonComponent } from './components/dashboard-common.component';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { DashboardMenuListComponent } from './components/dashboard-menu-list/dashboard-menu-list.component';
import { PricingPolicyComponent } from './pricing-policy/pricing-policy.component';
import { RefundPolicyComponent } from './refund-policy/refund-policy.component';
import { ShippingPolicyComponent } from './shipping-policy/shipping-policy.component';
import { CancellationPolicyComponent } from './cancellation-policy/cancellation-policy.component';
import { HeaderLatestComponent } from '../home/landing-root/header-latest/header-latest.component';
import { FooterMoreInfoComponent } from '../home/landing-root/footer-more-info/footer-more-info.component';
import { OurAppsComponent } from '../home/about-root/our-apps/our-apps.component';
import { ChatWidgetComponent } from './components/widgets/chat-widget/chat-widget.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { NewJobsCardsComponent } from './new-jobs-cards/new-jobs-cards.component';



@NgModule({
  declarations: [
    HeaderOneComponent,
    FooterOneComponent,
    HeaderTwoComponent,
    FooterTwoComponent,
    HeaderThreeComponent,
    FooterThreeComponent,
    HeaderFourComponent,
    FooterFourComponent,
    LeftMenuComponent,
    MenuComponent,
    SettingsComponent,
    BreadcrumbComponent,
    CategoriesComponent,
    ProductBoxOneComponent,
    ProductBoxTwoComponent,
    ProductBoxThreeComponent,
    ProductBoxFourComponent,
    ProductBoxFiveComponent,
    ProductBoxVerticalComponent,
    ProductBoxVerticalSliderComponent,
    NewsletterComponent,
    QuickViewComponent,
    CartModalComponent,
    CartVariationComponent,
    VideoModalComponent,
    SizeModalComponent,
    AgeVerificationComponent,
    SkeletonProductBoxComponent,
    LayoutBoxComponent,
    TapToTopComponent,
    DiscountPipe,
    DialogCountBlessingsComponent,
    // TabTableComponent,
    // TabComponentComponent,
    // CardSimpleComponent,
    PopUpComponent,
    TopCollectionComponent,
    ExclusiveFeaturesComponent,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
    CollapsibleComponent,
    FaqsListComponent,
    DashboardCommonComponent,
    DashboardMenuListComponent,
    PricingPolicyComponent,
    RefundPolicyComponent,
    ShippingPolicyComponent,
    CancellationPolicyComponent,
    SafeUrlPipe,
    NewJobsCardsComponent
    // ChatWidgetComponent

  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    CarouselModule,
    BarRatingModule,
    LazyLoadImageModule,
    NgxSkeletonLoaderModule,
    TranslateModule,
    MatDialogModule,
    MatInputModule,
    MatFormFieldModule,
    MatStepperModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatOptionModule,
    MatSelectModule,
    MatTabsModule,
    UnixTimestampToDatePipe,
    MatSnackBarModule,
    MatTooltipModule,
    HeaderLatestComponent,
    FooterMoreInfoComponent
    ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    CarouselModule,
    BarRatingModule,
    LazyLoadImageModule,
    NgxSkeletonLoaderModule,
    TranslateModule,
    HeaderOneComponent,
    FooterOneComponent,
    HeaderTwoComponent,
    FooterTwoComponent,
    HeaderThreeComponent,
    FooterThreeComponent,
    HeaderFourComponent,
    FooterFourComponent,
    BreadcrumbComponent,
    CategoriesComponent,
    ProductBoxOneComponent,
    ProductBoxTwoComponent,
    ProductBoxThreeComponent,
    ProductBoxFourComponent,
    ProductBoxFiveComponent,
    ProductBoxVerticalComponent,
    ProductBoxVerticalSliderComponent,
    NewsletterComponent,
    QuickViewComponent,
    CartModalComponent,
    CartVariationComponent,
    VideoModalComponent,
    SizeModalComponent,
    AgeVerificationComponent,
    SkeletonProductBoxComponent,
    LayoutBoxComponent,
    TapToTopComponent,
    DiscountPipe,
    PopUpComponent,
    TopCollectionComponent,
    ExclusiveFeaturesComponent,
    CollapsibleComponent,
    UnixTimestampToDatePipe,
    FaqsListComponent,
    DashboardCommonComponent,
    SafeUrlPipe,
    NewJobsCardsComponent
    // ChatWidgetComponent
    
    // CardsComponent
  ]
})
export class SharedModule { }
